import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  width: 70%;
  margin: 0 auto;
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;
